/* tslint:disable */
/* eslint-disable */
/**
 * Nightingale API
 *  ### Welcome to the Nightingale API !   To use the Nightingale API, you will need a `access_token` from **Bridgetech Support**  ## How to use swagger documentation   Click `Authorize` and paste your  `access_token` as `bearerAuth`  ## Design Notes 1. For non-mandatory fields, the API will allow you to submit `null` *or* omit fields entirely. 2. All query parameters are optional. Pagination fields default as follows: * page = 1 * limit = 20
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Audit } from './Audit';
import {
    AuditFromJSON,
    AuditFromJSONTyped,
    AuditToJSON,
    AuditToJSONTyped,
} from './Audit';
import type { GetAudits200ResponseMeta } from './GetAudits200ResponseMeta';
import {
    GetAudits200ResponseMetaFromJSON,
    GetAudits200ResponseMetaFromJSONTyped,
    GetAudits200ResponseMetaToJSON,
    GetAudits200ResponseMetaToJSONTyped,
} from './GetAudits200ResponseMeta';
import type { GetAudits200ResponseLinks } from './GetAudits200ResponseLinks';
import {
    GetAudits200ResponseLinksFromJSON,
    GetAudits200ResponseLinksFromJSONTyped,
    GetAudits200ResponseLinksToJSON,
    GetAudits200ResponseLinksToJSONTyped,
} from './GetAudits200ResponseLinks';

/**
 * 
 * @export
 * @interface GetAudits200Response
 */
export interface GetAudits200Response {
    /**
     * 
     * @type {Array<Audit>}
     * @memberof GetAudits200Response
     */
    data: Array<Audit>;
    /**
     * 
     * @type {GetAudits200ResponseLinks}
     * @memberof GetAudits200Response
     */
    links: GetAudits200ResponseLinks;
    /**
     * 
     * @type {GetAudits200ResponseMeta}
     * @memberof GetAudits200Response
     */
    meta: GetAudits200ResponseMeta;
}

/**
 * Check if a given object implements the GetAudits200Response interface.
 */
export function instanceOfGetAudits200Response(value: object): value is GetAudits200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('links' in value) || value['links'] === undefined) return false;
    if (!('meta' in value) || value['meta'] === undefined) return false;
    return true;
}

export function GetAudits200ResponseFromJSON(json: any): GetAudits200Response {
    return GetAudits200ResponseFromJSONTyped(json, false);
}

export function GetAudits200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAudits200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(AuditFromJSON)),
        'links': GetAudits200ResponseLinksFromJSON(json['links']),
        'meta': GetAudits200ResponseMetaFromJSON(json['meta']),
    };
}

export function GetAudits200ResponseToJSON(json: any): GetAudits200Response {
    return GetAudits200ResponseToJSONTyped(json, false);
}

export function GetAudits200ResponseToJSONTyped(value?: GetAudits200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(AuditToJSON)),
        'links': GetAudits200ResponseLinksToJSON(value['links']),
        'meta': GetAudits200ResponseMetaToJSON(value['meta']),
    };
}

